import { Component, OnInit, HostListener, ElementRef, ChangeDetectorRef  } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { RestService } from 'src/app/services/rest-service';
import { AccountConfigurationComponent } from 'src/app/pages/account-configuration/account-configuration.component';
import { SpinnerService } from 'src/app/components/spinner-component/spinner.service';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import { URLs } from '../../../assets/files/help';
import { AppSettings } from 'src/app/shared/app-settings';
import { Subscription } from 'rxjs';
import { ConfigService } from 'src/app/services/config.service';
import { ArchiveDashboardService } from 'src/app/components/user-behaviour/archive-dashboard/archive-dashboard.service';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: false
})
export class HeaderComponent implements OnInit {
  currentuser: any;
  username: string;
  userImage: string;
  userEmail: string;
  readOnlyUser: boolean = false;
  viewSites: boolean = false;
  viewDevices: boolean = false;
  viewDashboard: boolean = false;
  viewSettings: boolean = false;
  zendeskComments: boolean = false;
  viewCloudInfra: boolean = false;
  viewHelp:boolean = false;
  viewApps:boolean = false;
  viewCameraConfig:boolean = false;
  editCameraConfig:boolean = false;
  accountConfigurations:boolean = false;
  unitId='';
  showHead: boolean = false;
  isLoading: boolean = false;
  imageSub : Subscription;
  showCameraServer: boolean = false;
  showUPtime: boolean = false;
  axisActiveData: any = null;
  formattedExcelData: any[] = [];
  dataLoaded: boolean = false;
  buttonDisabled = false;
  urls = URLs;
  editEc2Config = false;
  viewProview = false;
  userMgmt = false;
  hasAdminRole = false;
  isCPEnabled = false;
  hasViewUserRole: boolean;
  hasEditUserRole: boolean;
  isAdminUser: boolean;
  constructor(
    public authService: AuthenticationService,
    public restService: RestService,
    private router: Router,
    public dialog: MatDialog,
    public spinner: SpinnerService,
    private toastr: ToastrService,
    private changeDetector: ChangeDetectorRef,
    public configService: ConfigService,
  ) { 
    router.events.forEach((event) => {
      if (event instanceof NavigationStart) {
        if (event['url'] == '/login' || event['url'] == '/' || event['url'].includes('/login') || event['url'].includes('/auth/portal/sso-login') ) {
          this.showHead = false;
        } else {
          this.showHead = true;
        }
      }
    });
    setTimeout(() => {
      this.authService.currentUserSubject.subscribe((res: any) => {
        this.viewProview = this.authService.hasPrivilege('View Proview');
        this.hasAdminRole = this.authService.hasAdminPrivilege();
        this.userMgmt = this.configService.isFeatureEnabled('userMgmt'); 
        this.hasViewUserRole = this.authService.hasViewUserPrivilege();
        this.hasEditUserRole = this.authService.hasEditUserPrivilege();
        this.currentUserPermissions();
      });
    }, 0);
  
  }

  ngOnInit() {
    this.imageSub = this.authService.getImage().subscribe(res => {
      if(res) {
        this.userImage = res.picture;
        this.userEmail = res.email;
        this.imageSub.unsubscribe();
      }
    })
    this.currentuser = this.authService.currentUserValue;
    let user = JSON.parse(localStorage.getItem('loggedInUser') || '{}');
    this.userImage = user.picture;
    this.userEmail = user['email'];
    this.showCameraServer = this.configService.isFeatureEnabled('cameraServer');
    this.isCPEnabled = this.configService.isFeatureEnabled('cpLogs');

    this.isAdminUser = ArchiveDashboardService.isAdminUser(this.currentuser?.email);

    window.addEventListener('scroll', function() {
      navbarScroll();
     });
     function navbarScroll() {
       var y = window.scrollY;
       if (y > 10) {
         var header = document.getElementsByClassName('header')[0];
         if(header&&header.classList){
          header.classList.add('small');
        }
       } else if (y < 10) {
           var header = document.getElementsByClassName('header')[0];
            if(header&&header.classList){
              header.classList.remove('small');
            }
       }
     };
  }

  ngAfterContentChecked(): void {
    this.changeDetector.detectChanges();
  }
  
  currentUserPermissions(){
    this.currentuser = this.authService.currentUserValue;
    if (this.currentuser) {
      this.username = this.currentuser.firstName;
      if (this.currentuser['privileges'] && this.currentuser['privileges'].length > 0) {
        for (let i = 0; i < this.currentuser['privileges'].length; i++) {
          switch (this.currentuser['privileges'][i].toLowerCase()) {
            case 'view settings':
              this.readOnlyUser = true;
              break;
            case 'view dashboard':
              this.viewDashboard = true;
              break;
            case 'view devices':
              this.viewDevices = true;
              break;
            case 'view sites':
              this.viewSites = true;
              break;
            case 'view cloud infrastructure':
              this.viewCloudInfra = true;
              break;
            case 'view help':
              this.viewHelp = true;
              break;
            case 'view apps':
                this.viewApps = true;
              break;
            case 'view zendesk comments':
              this.zendeskComments = true;
              break;
            case 'view account configurations':
              this.accountConfigurations = true;
              break;
            case 'edit camera configuration':
              this.editCameraConfig = true;
              break;
            case 'view camera configuration':
              this.viewCameraConfig = true;
              break;         
            case 'edit ec2 config':
              this.editEc2Config = true;
              break;
            case 'view proview':
              this.viewProview = true;
              break;
          }
        }
      }
    }
    this.upTimePermission()
  }

  upTimePermission(){
    this.currentuser = this.authService.currentUserValue;
    if (this.currentuser) {
      this.username = this.currentuser.firstName;
      const roles = this.currentuser['role'].map(role => role.toLowerCase());
      this.showUPtime = roles[0].includes('us tss') || roles.includes('india tss') || roles.includes('admin');
    }
  }

  logout() {
    this.authService.logout();
    this.router.navigate(['/login']);
  }

  showDashboard() {
    this.router.navigateByUrl('/home');
  }

  navigatePrivilege() {
    this.router.navigateByUrl('/privilege');
  }

  navigateRoles() {
    this.router.navigateByUrl('/roles');
  }

  navigateUserManagement() {
    this.router.navigateByUrl('/user-management');
  }

  navigateAccountConfiguration() {
    this.dialog.open(AccountConfigurationComponent,{
      width: '90vw',
      height: '90vh',
      maxWidth: '90vw',
      panelClass: 'centered-modal',
    });
  }
  
  navigateZendeskComments(){
    this.router.navigateByUrl('/zendesk-comments');
  }


  formatExcelData(){
    this.formattedExcelData = [];
    let url = AppSettings.ACTIVE_AXIS_CAMDATA;
    this.restService.getRequest(url,'').subscribe((x)=>{
    this.axisActiveData = x.data;
    if (this.axisActiveData) {
        for (const key in this.axisActiveData) {
            const dataItem = this.axisActiveData[key];

            if (dataItem) {
                this.formattedExcelData.push({
                    prodShortName: dataItem?.prodShortName ? dataItem?.prodShortName : 'N/A',
                    wdr: dataItem?.wdr ? dataItem?.wdr : 'N/A',
                    irCutFilter: dataItem?.irCutFilter ? dataItem?.irCutFilter : 'N/A',
                    maxShutter: dataItem?.maxShutter ? dataItem?.maxShutter : 'N/A',
                    maxGain: dataItem.maxGain ? dataItem.maxGain : 'N/A',
                    lowNoise: dataItem.lowNoise ? dataItem.lowNoise : 'N/A',
                    exposureLevel: dataItem.exposureLevel ? dataItem.exposureLevel : 'N/A',
                    resolution: dataItem.resolution ? dataItem.resolution : 'N/A',
                    frameRate: dataItem.frameRate ? dataItem.frameRate : 'N/A',
                    compression: dataItem.compression ? dataItem.compression : 'N/A',
                    zipStream: dataItem.zipStream ? dataItem.zipStream : 'N/A',
                    bitrateControl: dataItem.bitrateControl ? dataItem.bitrateControl : 'N/A',
                    date: dataItem.date ? dataItem.date : 'N/A',
                    clock: dataItem.clock ? dataItem.clock : 'N/A',
                    timeZone: dataItem.timeZone ? dataItem.timeZone : 'N/A',
                    ntpServer: dataItem.ntpServer ? dataItem.ntpServer : 'N/A',
                    dhcpServer: dataItem.dhcpServer ? dataItem.dhcpServer : 'N/A',
                    timesSyncSource: dataItem.timesSyncSource ? dataItem.timesSyncSource : 'N/A',
                    aid7Details: dataItem.aid7Details ? dataItem.aid7Details : 'N/A',
                    screenProfileAID7: dataItem.screenProfileAID7 ? dataItem.screenProfileAID7 : 'N/A',
                    sdCard: dataItem.sdCard ? dataItem.sdCard : 'N/A',
                    storageLimit: dataItem.storageLimit ? dataItem.storageLimit : 'N/A',
                    recordings: dataItem.recordings ? dataItem.recordings : 'N/A',
                    prodFullName: dataItem.prodFullName ? dataItem.prodFullName : 'N/A',
                    httpsPort: dataItem.httpsPort ? dataItem.httpsPort : 'N/A',
                    hostName: dataItem.hostName ? dataItem.hostName : 'N/A',
                    ipAddress: dataItem.ipAddress ? dataItem.ipAddress : 'N/A',
                    macAddress: dataItem.macAddress ? dataItem.macAddress : 'N/A',
                    firmwareManagementVersion: dataItem.firmwareManagementVersion ? dataItem.firmwareManagementVersion : 'N/A',
                    systemBoaPort: dataItem.systemBoaPort ? dataItem.systemBoaPort : 'N/A',
                    cameraUniqueld: dataItem.cameraUniqueld ? dataItem.cameraUniqueld : 'N/A',
                    buildDate: dataItem.buildDate ? dataItem.buildDate : 'N/A',
                    buildNumber: dataItem.buildNumber ? dataItem.buildNumber : 'N/A',
                    firmwareVersion: dataItem.firmwareVersion ? dataItem.firmwareVersion : 'N/A',
                    fps: dataItem.fps ? dataItem.fps : 'N/A',
                    height: dataItem.height ? dataItem.height : 'N/A',
                    ir: dataItem.ir ? dataItem.ir : 'N/A',
                    serialNumber: dataItem.serialNumber ? dataItem.serialNumber : 'N/A',
                    width: dataItem.width ? dataItem.width : 'N/A',
                    exposureValue: dataItem.exposureValue ? dataItem.exposureValue : 'N/A',
                    pframes: dataItem.pframes ? dataItem.pframes : 'N/A',
                    pcount: dataItem.pcount ? dataItem.pcount : 'N/A',
                });
            }
        }
    }
  })
}


  public downloadExcelTrigger() {
    const downloadLink = document.createElement('a');
    downloadLink.href = AppSettings.API_ENDPOINT + '/' + AppSettings.AXIS_DOWNLOAD; 
    downloadLink.click();
  }

  openLink(url: string){
    window.open(url, "_blank");
 }

 appLinks(urlKey: string): void {
  const url = this.urls[urlKey];
  if (url) {
    window.open(url, '_blank');
  }
}

 mdxDeviceData(){
  let url = AppSettings.X310_SAVED;
  this.toastr.success('Requested Data Emailed');
  this.restService.getRequest(url, '').subscribe({
    next: (response) => {
      if (response && response.success == true) {
        
      } else {
        this.toastr.error('Please try again later');
      }
    },
    error: (error) => {
      this.toastr.error('Please try again');
    },
    complete: () => {
      
    }
  });
}

// routerInfoReport(){
//   let url = `${AppSettings.ROUTER_REPORT}${this.userEmail}`;
//   this.toastr.success('The requested data will be emailed within 30 minutes');
//   this.restService.getRequest(url,'').subscribe({
//     next: (response) => {
//       if (response && response.success == true) {
        
//       } else {
//         this.toastr.error('Please try again later');
//       }
//     },
//     error: (error) => {
//       this.toastr.error('Please try again');
//     },
//     complete: () => {
      
//     }
//   })
// }

 allSiteUptime(){
    let url = AppSettings.UPTIME_REPORT;
    this.toastr.success('Your requested data will be emailed within 30 minutes');
    let payLoad = {
      emailId : this.userEmail
    }
    this.restService.getRequest(url,payLoad).subscribe({
      next: (response) => {
      }
    })
  }

  isShow: boolean;
  topPosToStartShowing = 100;

  @HostListener('window:scroll')
  checkScroll() {
    const scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;

    
    if (scrollPosition >= this.topPosToStartShowing) {
      this.isShow = true;
    } else {
      this.isShow = false;
    }
  }
  gotoTop() {
    window.scroll({ 
      top: 0, 
      left: 0, 
      behavior: 'smooth' 
    });
  }


}
